export const MODEL_DOCUMENT_TYPE_DRIVER_LICENSE = 'driver_license';
export const MODEL_DOCUMENT_TYPE_PASSPORT = 'passport';
export const MODEL_DOCUMENT_TYPE_ID_CARD = 'id_card';
export const MODEL_DOCUMENT_TYPE_SCHENGEN_VISA = 'schengen_visa';
export const MODEL_DOCUMENT_TYPE_VISA = 'visa';
export const MODEL_DOCUMENT_TYPE_OTHER = 'other';